"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createGuid = _interopRequireDefault(require("../../../../helpers/createGuid"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _FormGroup = _interopRequireDefault(require("../../FormGroup/FormGroup"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Dropdown = ({
  label,
  input,
  tabIndex,
  options,
  showEmptyValue,
  emptyValueLabel,
  ...otherProps
}) => {
  const guid = (0, _createGuid.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup.default, { ...otherProps,
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, {
      htmlFor: guid,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
      options: options,
      input: input,
      id: guid,
      tabIndex: tabIndex,
      showEmptyValue: showEmptyValue,
      emptyValueLabel: emptyValueLabel
    })]
  });
};

Dropdown.propTypes = {
  label: _propTypes.default.string,
  input: _propTypes.default.object,
  tabIndex: _propTypes.default.number,
  options: _propTypes.default.array,
  showEmptyValue: _propTypes.default.bool,
  emptyValueLabel: _propTypes.default.string
};
var _default = Dropdown;
exports.default = _default;